
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-employers/think-it-magazyn-hr",
      function () {
        return require("private-next-pages/for-employers/think-it-magazyn-hr.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-employers/think-it-magazyn-hr"])
      });
    }
  